export default "__VITE_ASSET__BQabSn7r__"